import React, { useEffect } from "react";
import usePasses from "./hooks/useMixedTicket";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import useFacility from "../../../utils/hooks/useFacility";
import PassesColorPage from "../LimitedTicket/PassesColorPage";

const MixedTicket: React.FC = () => {
  const { requestGetAssortGroups } = usePasses();
  const facilityIds = useFacility();

  useEffect(() => {
    if (Boolean(facilityIds)) {
      requestGetAssortGroups();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  return (
    <React.Fragment>
      <div>
        <PassesColorPage />
      </div>
    </React.Fragment>
  );
};

export default MixedTicket;
